import {useState} from "react";
import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import SchemaFieldList from "./SchemaFieldList";
import style from "../style/SchemaTool.module.scss";

const cn = className.bind(style);

/**
 * Nhóm field cho 1 entity con (field type='object', vd address/offers).
 * Render 1 khung có tiêu đề + danh sách field con (đệ quy qua SchemaFieldList).
 *
 * Có thể THU GỌN (bấm tiêu đề) để form dài (vd LocalBusiness) không thành 1 cột vô tận:
 * mặc định đóng nếu nhóm không bắt buộc/không rich và chưa có dữ liệu; tự mở khi có
 * dữ liệu (điền mẫu / mở lại schema đã lưu).
 */
function NestedFieldGroup({field, value, onChange}) {

	const hasValue = value && Object.keys(value).length > 0;
	const [manual, setManual] = useState(null); // null = tự động theo required/rich/dữ liệu
	const collapsed = manual !== null ? manual : !(field.required || field.rich || hasValue);

	return (
		<div className={cn('nested', {collapsed})}>
			<button type="button" className={cn('nested-head')} onClick={() => setManual(!collapsed)}>
				<FontAwesomeIcon icon={collapsed ? 'fa-light fa-chevron-right' : 'fa-light fa-chevron-down'} />
				{field.label}
				{field.required && <span className={cn('req')}> *</span>}
				{field.rich && <span className={cn('rich-badge')}>rich result</span>}
				<span className={cn('nested-type')}>{field.of}</span>
			</button>
			{!collapsed && (
				<div className={cn('nested-body')}>
					<SchemaFieldList fields={field.fields} values={value || {}} onChange={onChange} />
				</div>
			)}
		</div>
	);
}

export default NestedFieldGroup;
